import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export function PumpSVG({ value, config = {}, width = 50, height = 50 }) {
    const running = parseFloat(value) >= (parseFloat(config.threshold ?? 0.5));
    const color = running ? (config.run_color || '#22C55E') : (config.stop_color || '#64748B');
    const cx = width / 2, cy = height / 2;
    const r = Math.min(width, height) / 2 - 4;

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
            {/* Outer circle */}
            <circle cx={cx} cy={cy} r={r} fill="#1E293B" stroke={color} strokeWidth={2} />
            {/* Impeller blades */}
            {[0, 120, 240].map(angle => {
                const rad = (angle + (running ? Date.now() / 50 : 0)) * Math.PI / 180;
                const x1 = cx + Math.cos(rad) * r * 0.3;
                const y1 = cy + Math.sin(rad) * r * 0.3;
                const x2 = cx + Math.cos(rad) * r * 0.85;
                const y2 = cy + Math.sin(rad) * r * 0.85;
                return <line key={angle} x1={x1} y1={y1} x2={x2} y2={y2} stroke={color} strokeWidth={3} strokeLinecap="round" />;
            })}
            {/* Center dot */}
            <circle cx={cx} cy={cy} r={4} fill={color} />
        </svg>
    );
}

export default function PumpNode(props) {
    const { data } = props;
    return (
        <BaseScadaNode {...props}>
            <PumpSVG value={data?.liveValue} config={data?.config} width={data?.width || 50} height={data?.height || 50} />
            {data?.label && (
                <div style={{ textAlign: 'center', fontSize: 10, color: '#94A3B8', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                    {data.label}
                </div>
            )}
        </BaseScadaNode>
    );
}
